import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BundleType, CardStyleType, NodeModel } from '../../../common/models';
import { SwiperComponent } from '../../../common/components';


@Component({
    selector: 'lib-content-highlight-widget',
    templateUrl: './content-highlight-widget.component.html',
    styleUrls: ['./content-highlight-widget.component.scss'],
    standalone: false
})
export class ContentHighlightWidgetComponent {
  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  @Input() public title: string;
  @Input() public items: NodeModel[] = [];
  @Input() public textColor: string;
  @Input() public langcode: string;
  @Input() public sliderEnabled = false;
  @Input() public mobileCardStyle: string;
  @Input() public isPaymentEnabled = false;
  @Input() public courseDetailsEnabled = false;

  @Output() public openDetails: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public navigateToEntity: EventEmitter<{ event: Event, item: NodeModel }> = new EventEmitter();

  public readonly bundleTypes: typeof BundleType = BundleType;
  public readonly mobileCardStyleTypes: typeof CardStyleType = CardStyleType;

  public swiperOptions = {
    breakpoints: {
      0: {
        slidesPerView: 1,
        showOverflow: true,
        reducedWidth: true
      },
      480: {
        slidesPerView: 2,
        showOverflow: false,
        reducedWidth: false
      },
      640: {
        slidesPerView: 3,
        showOverflow: false,
        reducedWidth: false
      },
      1024: {
        slidesPerView: 4,
        showOverflow: false,
        reducedWidth: false
      }
    }
  };

  public navigate(event: Event, item: NodeModel): void {
    this.navigateToEntity.emit({ event, item });
  }
}
